import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../src/Pages/Home';
import CertificatePage from './Pages/CertificatePage';
import WorkPage from './Pages/WorkPage';
import Admin from './Pages/Admin/Admin';
import AdminMainPage from './Pages/Admin/AdminMainPage';
import UploadTestimonial from './Pages/Admin/UploadTestimonials';
import UploadCertificate from './Pages/Admin/UploadCertificates';
import UploadProject from './Pages/Admin/UploadProjects';

function App() {
  const isLoggedIn = window.localStorage.getItem('authenticated')
  return (
    <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='/certificate' element={<CertificatePage/>} />
          <Route path='/work' element={<WorkPage/>} />
          <Route path='/auth' element={isLoggedIn === 'true' ? <AdminMainPage /> : <Admin />} />
          <Route path='/admin' element={isLoggedIn === 'true' ? <AdminMainPage /> : <Admin />} />
          <Route path='/adminpage' element={isLoggedIn === 'true' ? <AdminMainPage /> : <Admin />} />
          <Route path='/admin/uploadtestimonials' element={isLoggedIn === 'true'? <UploadTestimonial />: <Admin />} />
          <Route path='/admin/uploadcertificate' element={isLoggedIn === 'true'? <UploadCertificate/> : <Admin /> } />
          <Route path='/admin/uploadprojects' element={isLoggedIn === 'true'? <UploadProject/> : <Admin />} />
        </Routes>
    </Router>
  );
}

export default App;
